// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change Language — mobile-first, brand-aware, light/dark */

.change-lng-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--bg-color, #0f1115);
  color: var(--text-color, #f5f5f7);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.change-lng-page .exercise-header {
  position: sticky;
  top: 0;
  z-index: 10;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  background: color-mix(in srgb, var(--bg-color, #0f1115) 82%, transparent);
  border-bottom: 1px solid var(--border-color, rgba(255, 255, 255, 0.06));
}

.change-lng {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 12px 16px 40px;
  box-sizing: border-box;
}

.change-lng__hint {
  margin: 4px 4px 14px;
  font-family: var(--brand-font, Poppins), system-ui, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: -0.01em;
  color: var(--text-secondary, var(--brand-text-secondary, #838383));
}

.change-lng__list {
  list-style: none;
  margin: 0;
  padding: 4px 0;
  border-radius: 16px;
  background: var(--glass-bg, rgba(255, 255, 255, 0.04));
  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));
  box-shadow: 0 8px 24px var(--shadow-color, rgba(0, 0, 0, 0.18));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  overflow: hidden;
}

.change-lng__item-wrap {
  margin: 0;
  padding: 0;
}

.change-lng__divider {
  height: 1px;
  margin-left: 68px;
  background: var(--border-color, rgba(255, 255, 255, 0.08));
}

.change-lng__item {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  margin: 0;
  padding: 14px 16px;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  text-align: left;
  box-sizing: border-box;
  min-height: 56px;
  transition:
    background-color 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1);
  -webkit-tap-highlight-color: transparent;
}

.change-lng__item:hover {
  background: var(--profile-hover-bg, rgba(255, 255, 255, 0.05));
}

.change-lng__item:active {
  transform: scale(0.985);
  background: var(--profile-hover-bg, rgba(255, 255, 255, 0.08));
}

.change-lng__item:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: -2px;
}

.change-lng__item.is-selected {
  background: color-mix(
    in srgb,
    var(--brand-primary, #0877bc) 14%,
    transparent
  );
}

.change-lng__item.is-selected:hover {
  background: color-mix(
    in srgb,
    var(--brand-primary, #0877bc) 20%,
    transparent
  );
}

.change-lng__item.is-pending {
  opacity: 0.85;
}

.change-lng__flag {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 22px;
  line-height: 1;
  background: color-mix(
    in srgb,
    var(--brand-primary, #0877bc) 12%,
    var(--surface-color, rgba(255, 255, 255, 0.06))
  );
  border: 1px solid
    color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
  box-shadow: 0 2px 8px
    color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);
}

.change-lng__meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.change-lng__name {
  font-family: var(--brand-font, Poppins), system-ui, sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--text-color, #f5f5f7);
}

.change-lng__item.is-selected .change-lng__name {
  color: var(--brand-primary-light, var(--brand-primary, #0a8cd8));
}

.change-lng__code {
  font-family: var(--brand-font, Poppins), system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary, #838383);
}

.change-lng__check {
  flex-shrink: 0;
  color: var(--brand-primary, #0877bc);
}

.change-lng__spacer {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Light mode refinements */
.light-mode .change-lng-page,
html.light-mode .change-lng-page {
  background: var(--bg-color, var(--brand-bg, #f4f5f6));
}

.light-mode .change-lng__list,
html.light-mode .change-lng__list {
  background: var(--glass-bg, var(--brand-surface, #ffffff));
  border-color: var(--glass-border, rgba(0, 0, 0, 0.06));
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}

.light-mode .change-lng__item.is-selected .change-lng__name,
html.light-mode .change-lng__item.is-selected .change-lng__name {
  color: var(--brand-primary-dark, var(--brand-primary, #065a8f));
}

.light-mode .change-lng__flag,
html.light-mode .change-lng__flag {
  background: color-mix(
    in srgb,
    var(--brand-primary, #0877bc) 10%,
    #ffffff
  );
}

/* Desktop: slightly roomier, still single-column composition */
@media (min-width: 640px) {
  .change-lng {
    padding: 20px 24px 48px;
  }

  .change-lng__list {
    border-radius: 18px;
  }

  .change-lng__item {
    padding: 16px 20px;
    min-height: 60px;
  }

  .change-lng__name {
    font-size: 17px;
  }

  .change-lng__divider {
    margin-left: 74px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .change-lng__item,
  .change-lng-page {
    transition: none;
  }

  .change-lng__item:active {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/common/ChangeLng.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,2BAA2B;EAC3B,mCAAmC;EACnC,yEAAyE;EACzE,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,sDAAsD;EACtD,gEAAgE;EAChE,+DAA+D;EAC/D,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB;;iDAE+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd;;;;GAIC;EACD;sEACoE;EACpE;sEACoE;AACtE;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;;EAEE,qDAAqD;AACvD;;AAEA;;EAEE,0DAA0D;EAC1D,sDAAsD;EACtD,0CAA0C;AAC5C;;AAEA;;EAEE,+DAA+D;AACjE;;AAEA;;EAEE;;;;GAIC;AACH;;AAEA,+DAA+D;AAC/D;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Change Language — mobile-first, brand-aware, light/dark */\n\n.change-lng-page {\n  min-height: 100vh;\n  min-height: 100dvh;\n  background: var(--bg-color, #0f1115);\n  color: var(--text-color, #f5f5f7);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.change-lng-page .exercise-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  background: color-mix(in srgb, var(--bg-color, #0f1115) 82%, transparent);\n  border-bottom: 1px solid var(--border-color, rgba(255, 255, 255, 0.06));\n}\n\n.change-lng {\n  width: 100%;\n  max-width: 520px;\n  margin: 0 auto;\n  padding: 12px 16px 40px;\n  box-sizing: border-box;\n}\n\n.change-lng__hint {\n  margin: 4px 4px 14px;\n  font-family: var(--brand-font, Poppins), system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.35;\n  letter-spacing: -0.01em;\n  color: var(--text-secondary, var(--brand-text-secondary, #838383));\n}\n\n.change-lng__list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  border-radius: 16px;\n  background: var(--glass-bg, rgba(255, 255, 255, 0.04));\n  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));\n  box-shadow: 0 8px 24px var(--shadow-color, rgba(0, 0, 0, 0.18));\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  overflow: hidden;\n}\n\n.change-lng__item-wrap {\n  margin: 0;\n  padding: 0;\n}\n\n.change-lng__divider {\n  height: 1px;\n  margin-left: 68px;\n  background: var(--border-color, rgba(255, 255, 255, 0.08));\n}\n\n.change-lng__item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  margin: 0;\n  padding: 14px 16px;\n  border: none;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  text-align: left;\n  box-sizing: border-box;\n  min-height: 56px;\n  transition:\n    background-color 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.change-lng__item:hover {\n  background: var(--profile-hover-bg, rgba(255, 255, 255, 0.05));\n}\n\n.change-lng__item:active {\n  transform: scale(0.985);\n  background: var(--profile-hover-bg, rgba(255, 255, 255, 0.08));\n}\n\n.change-lng__item:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: -2px;\n}\n\n.change-lng__item.is-selected {\n  background: color-mix(\n    in srgb,\n    var(--brand-primary, #0877bc) 14%,\n    transparent\n  );\n}\n\n.change-lng__item.is-selected:hover {\n  background: color-mix(\n    in srgb,\n    var(--brand-primary, #0877bc) 20%,\n    transparent\n  );\n}\n\n.change-lng__item.is-pending {\n  opacity: 0.85;\n}\n\n.change-lng__flag {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  font-size: 22px;\n  line-height: 1;\n  background: color-mix(\n    in srgb,\n    var(--brand-primary, #0877bc) 12%,\n    var(--surface-color, rgba(255, 255, 255, 0.06))\n  );\n  border: 1px solid\n    color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n  box-shadow: 0 2px 8px\n    color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);\n}\n\n.change-lng__meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.change-lng__name {\n  font-family: var(--brand-font, Poppins), system-ui, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--text-color, #f5f5f7);\n}\n\n.change-lng__item.is-selected .change-lng__name {\n  color: var(--brand-primary-light, var(--brand-primary, #0a8cd8));\n}\n\n.change-lng__code {\n  font-family: var(--brand-font, Poppins), system-ui, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #838383);\n}\n\n.change-lng__check {\n  flex-shrink: 0;\n  color: var(--brand-primary, #0877bc);\n}\n\n.change-lng__spacer {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n/* Light mode refinements */\n.light-mode .change-lng-page,\nhtml.light-mode .change-lng-page {\n  background: var(--bg-color, var(--brand-bg, #f4f5f6));\n}\n\n.light-mode .change-lng__list,\nhtml.light-mode .change-lng__list {\n  background: var(--glass-bg, var(--brand-surface, #ffffff));\n  border-color: var(--glass-border, rgba(0, 0, 0, 0.06));\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n}\n\n.light-mode .change-lng__item.is-selected .change-lng__name,\nhtml.light-mode .change-lng__item.is-selected .change-lng__name {\n  color: var(--brand-primary-dark, var(--brand-primary, #065a8f));\n}\n\n.light-mode .change-lng__flag,\nhtml.light-mode .change-lng__flag {\n  background: color-mix(\n    in srgb,\n    var(--brand-primary, #0877bc) 10%,\n    #ffffff\n  );\n}\n\n/* Desktop: slightly roomier, still single-column composition */\n@media (min-width: 640px) {\n  .change-lng {\n    padding: 20px 24px 48px;\n  }\n\n  .change-lng__list {\n    border-radius: 18px;\n  }\n\n  .change-lng__item {\n    padding: 16px 20px;\n    min-height: 60px;\n  }\n\n  .change-lng__name {\n    font-size: 17px;\n  }\n\n  .change-lng__divider {\n    margin-left: 74px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .change-lng__item,\n  .change-lng-page {\n    transition: none;\n  }\n\n  .change-lng__item:active {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
